import React from 'react';
import { armsErrorSend } from '@/utils/libs/armsErrorSend';
import { feishuRobotSend } from '@/utils/feishuRobot';
import PageServerError from '../ErrorPage/PageServerError';

/**
 * 页面级错误捕获，捕获后兜底行为跳转pageError页面
 */
export default class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error, errorInfo) {
    feishuRobotSend({
      err: error,
      text: [`【PageErrorBoundary Catch】`, `【捕获 errorInfo】：${JSON.stringify(errorInfo ?? '')}`],
      at: ['dxy'],
    });
    armsErrorSend(error, { filename: 'PageErrorBoundary Catch' });
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <PageServerError />;
    }

    return this.props.children;
  }
}
